export default __webpack_public_path__ + "static/media/HDTX_Ringkasan Risalah RUPS Juni 2023.6f64d26d.pdf";